<template>
  <b-tooltip
    v-if="i18nKey"
    :label="$t(i18nKey)"
    position="is-right"
    multilined
    :append-to-body="true"
    class="filter-help-tooltip"
  >
    <b-icon
      icon="question-circle"
      type="is-dark"
      size="is-small"
    />
  </b-tooltip>
</template>

<script setup lang="ts">
/**
 * Icone "?" + tooltip d'aide rendu à côté du label d'un filtre . Une
 * unique source de rendu pour TOUS les filtres ( référence
 * autogénérée , FILTER_LIST , FILTER_TEXT , range numérique , range
 * date ) - le parent fournit simplement le {@link FilterHelpKind}
 * dérivé via {@link resolveFilterHelpKind} .
 *
 * <p><b>Pourquoi un composant dédié</b> :
 * <ul>
 *   <li><i>DRY</i> : avant cette extraction , chaque branche de
 *       {@code FiltersDataCollapse} dupliquait le markup
 *       {@code b-tooltip + b-icon} avec ses 5 props et sa classe CSS .
 *       Une seule définition désormais .</li>
 *   <li><i>SRP</i> : ce composant ne décide PAS quel libellé afficher
 *       - il consomme une clé i18n résolue . Le mapping checker -&gt; clé
 *       vit dans {@code filterHelpKey.ts} ( pur , testable ) .</li>
 *   <li><i>OCP</i> : ajouter un nouveau type de filtre = enrichir le
 *       helper + i18n , aucune modification de ce composant .</li>
 *   <li><i>Cohérence visuelle</i> : tous les filtres partagent
 *       strictement les mêmes attributs Buefy ( position , multilined ,
 *       append-to-body , taille / type d'icône ) .</li>
 * </ul>
 *
 * <p>Le tooltip est silencieusement masqué si {@code kind} vaut
 * {@code null} ( colonne non-filtrable ou sans aide définie ) , ce qui
 * permet aux callers de l'appeler inconditionnellement sans guard .
 */
import { computed } from "vue";
import {
  type FilterHelpKind,
  resolveFilterHelpI18nKey,
} from "@/composable/data/filterHelpKey";

const props = defineProps<{ kind: FilterHelpKind }>();

const i18nKey = computed<string | null>(() => resolveFilterHelpI18nKey(props.kind));
</script>
